import React, { useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import { ModalBody, ModalWrapper } from './SelectGroupMemberPopupStyled'
import { Button, Modal, Popconfirm, Space, Tag, Tooltip } from 'antd'
import {
  CloseOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { blue, yellowPrimary } from '../../color'
import { AvatarHasName } from '../Common/Avatar'
import { EmptyText } from '../Common/CellText'
import SelectGroupMemberBox from './SelectGroupMemberBox'
import { ASSIGNEE_TYPE } from '../../constants'

const SelectGroupMemberPopup = props => {
  const {
    isVisibleSelectGroupPopup,
    handleSubmitSelectGroup,
    handleCancelSelectGroup,
    selectPeopleStore,
  } = props

  const { selectGroupData, setSelectGroupData } = selectPeopleStore

  const onCancelSelectGroup = () => {
    handleCancelSelectGroup()
  }

  const handleRemoveSelect = useCallback(
    group => {
      setSelectGroupData({
        ...selectGroupData,
        [ASSIGNEE_TYPE.HANDLER]: selectGroupData[ASSIGNEE_TYPE.HANDLER].filter(
          el => el.id !== group.id
        ),
      })
    },
    [selectGroupData]
  )

  return (
    <Modal
      maskClosable={false}
      okText={'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={1200}
      footer={null}
      style={{ top: 20 }}
      wrapClassName="custom-modal-wrapper assign-member-modal"
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <span>Bảng chọn nhóm</span>
          <Space>
            <Popconfirm
              placement="bottom"
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={onCancelSelectGroup}
              okText="Đồng ý"
              cancelText="Không"
              zIndex={1600}>
              <Button danger>Hủy chọn</Button>
            </Popconfirm>
            <Button type={'primary'} onClick={handleSubmitSelectGroup}>
              Đồng ý
            </Button>
            <Tooltip title={'Đóng'}>
              <CloseOutlined
                onClick={handleSubmitSelectGroup}
                style={{
                  width: 24,
                  height: 24,
                }}
              />
            </Tooltip>
          </Space>
        </div>
      }
      closable={false}
      forceRender={true}
      visible={isVisibleSelectGroupPopup}>
      <div className="assign-member-modal-left-box">
        <div className="assign-member-modal-left-content">
          <SelectGroupMemberBox />
        </div>
      </div>

      <div className="assign-member-modal-right-box">
        <div
          style={{
            marginBottom: '16px',
            fontWeight: 500,
          }}>
          Danh sách đã chọn:
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
          }}>
          {selectGroupData[ASSIGNEE_TYPE.HANDLER].length > 0 ? (
            selectGroupData[ASSIGNEE_TYPE.HANDLER].map((el, index) => {
              return (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={index}
                  closable
                  onClose={() => handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={<TeamOutlined />}
                  />
                </Tag>
              )
            })
          ) : (
            <EmptyText>
              <span style={{ lineHeight: '34px' }}>
                Chưa có nhóm nào được chọn
              </span>
            </EmptyText>
          )}
        </div>
      </div>
    </Modal>
  )
}

SelectGroupMemberPopup.propTypes = {}

export default inject(
  'selectPeopleStore',
  'userStore'
)(observer(SelectGroupMemberPopup))
